<template>
  <div class="source-page">
    <div class="source-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="source-page-navigate-body position-relative">
        <div class="source-page-navigate-body-content safe-with flex-row-center-between">
          <p class="font-bold font-36 font-color-fff tit">检索结果</p>

        </div>
      </div>
    </div>
    <div v-if="cateAry.length" class="source-page-list">
      <div class="source-page-list-body safe-with flex">
        <div class="source-page-list-body-left flex-shrink">
          <div class="source-page-list-body-left-body">
            <div v-for="(item, index) in cateAry" :key="index" class="source-page-list-body-left-body-item flex-row-center cursor" :class="name==item?'sel':''" @click="newCateTap(item)">
              <p class="font-14">{{ item }}</p>
            </div>
          </div>
        </div>
        <div class="source-page-list-body-right flex-1">
          <div class="source-page-list-body-right-tit flex-row-center-between">
            <p class="font-bold font-16">{{ searchKey?("“"+searchKey+"”"+'检索结果'):'' }}</p>

            <p v-if="!sourceInfo" class="font-12">{{ name==='数字资源'?list.length:entities.length }}条</p>
            <p v-else class="font-12 cursor" @click="returnList">返回列表</p>
          </div>
          <div v-if="sourceInfo">
            <entity ref="entity" />
            <source-info ref="source" />

          </div>
          <div v-else>
            <div v-if="name==='数字资源'">
              <div v-if="list.length">
                <div style="min-height: 500px" class="source-page-list-body-right-list flex">
                  <div v-for="(item, index) in list" :key="index+'list'" class="source-page-list-body-right-list-item cursor" @click="toDetail(index)">
                    <div v-if="item.img" style="border: 1px solid #ddd" class="img flex-center" :style="{backgroundImage: 'url(' +'https://img.libraryplus.bjadks.com/'+ item.img + ')'}">
                      <!-- <img class="cursor" src="../../assets/img/icon-history-check.png"> -->
                    </div>
                    <div v-else style="border: 1px solid #ddd" class="default-img-cover img" />
                    <p class="tit font-14 text-line-1">{{ item.title }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="source-page-list-body-right-error flex-column-center">
                <img src="../../assets/img/icon-list-error.png">
                <p class="font-14 font-color-999">暂无数据</p>
              </div>
            </div>
            <div v-else>
              <div v-if="entities.length">
                <div style="min-height: 500px" class="source-page-list-body-right-list flex">
                  <div v-for="(item, index) in entities" :key="index+'entities'" class="source-page-list-body-right-list-item cursor" @click="toDetail(index)">
                    <div v-if="item.img" class="img flex-center" :style="{backgroundImage: 'url(' +'https://img.libraryplus.bjadks.com/'+ item.img + ')'}">
                      <!-- <img class="cursor" src="../../assets/img/icon-history-check.png"> -->
                    </div>
                    <div v-else class="default-img-cover img" />
                    <p class="tit font-14 text-line-1">{{ item.title }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="source-page-list-body-right-error flex-column-center">
                <img src="../../assets/img/icon-list-error.png">
                <p class="font-14 font-color-999">暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import entity from './components/detail/entity.vue'
import SourceInfo from './components/detail/sourceInfo'

export default {
  components: {
    SourceInfo,
    entity
  },
  data() {
    return {
      list: [],
      entities: [],
      currPage: 1,
      pages: 10,
      searchKey: '',
      cateAry: ['数字资源', '记忆本体'],
      listCata: [],
      name: '数字资源',
      sourceInfo: null

    }
  },
  watch: {
    $route(to, from) {
      this.searchKey = this.$route.query.key ?? ''
      this.sourceInfo = null
      this.request()
    }
  },

  created() {
    this.searchKey = this.$route.query.key ?? ''
    this.requestCatalog()
    this.request()
  },
  methods: {

    async requestCatalog() {
      const res = await api.getListByParentId({ parentId: 1012 })
      if (res.code === 2000) {
        console.log(res)
        this.listCata = res.items
      }
      this.request()
    },
    request() {
      api.search({
        keyWords: this.searchKey
      }).then(res => {
        console.log(res)
        if (res.code === 2000) {
          this.list = res.items.resources
          this.entities = res.items.entities
        }
      })
    },

    pageChage(v) {
      this.currPage = v
      this.request()
    },
    newCateTap(val) {
      if (val === this.name) {
        return
      }
      this.sourceInfo = null
      this.name = val
    },
    toDetail(val) {
      if (this.name === '数字资源') {
        this.sourceInfo = this.list[val]
        setTimeout(() => {
          this.$refs.source.showInfoId(this.sourceInfo.id, val, this.list)
        }, 100)
      } else {
        this.sourceInfo = this.entities[val]
        setTimeout(() => {
          this.$refs.entity.showInfoId(this.sourceInfo.id, val, this.entities, this.listCata)
        }, 100)
      }
    },

    returnList() {
      this.sourceInfo = null
    }

  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
  .source-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .source-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .source-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .source-page-navigate-body-content {
    padding-top: 120px;
  }

  .source-page-navigate-body-content .tit {
    line-height: 80px;

  }

  .source-page-navigate-body-content .search {
    width: 300px;
    height: 40px;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 0 10px;
  }

  .source-page-navigate-body-content .search img {
    margin-left: 10px;
  }

  .source-page-navigate-body-content .search input {
    outline: none;
    height: 100%;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
  }

  .source-page-navigate-body-content .search input::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  .source-page-list-body-right {
    margin-left: 40px;
  }

  .source-page-list-body-right-tit {
    margin-top: 10px;
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .source-page-list-body-right-tit p:last-child {
    color: #767676;
  }

  .source-page-list-body-left {
    width: 220px;
  }

  .source-page-list-body-right-list {
    padding-top: 30px;
    flex-wrap: wrap;
  }

  .source-page-list-body-right-list-item {
    margin-bottom: 30px;
    margin-right: 20px;
    width: 225px;
  }

  .source-page-list-body-right-list-item:nth-child(4n) {
    margin-right: 0;
  }

  .source-page-list-body-right-list-item .img {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 225px;
    height: 160px;
    border-radius: 5px;
  }

  .source-page-list-body-right-list-item .tit {
    line-height: 20px;
    color: #3D3D3D;
    margin-top: 10px;
  }

  .source-page-list-body-right-list-item .img img {
    opacity: 0;
  }

  .source-page-list-body-right-list-item .img:hover img {
    opacity: 1;
  }

  .source-page-list-body-right-list-page {
    margin: 60px 0;
  }

  .source-page-list-body-left-body {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.03) 100%);
  }

  .source-page-list-body-left-body-item {
    height: 50px;
    border-image: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%) 0 0 1 0;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    padding: 0 20px;
  }

  .source-page-list-body-left-body-item.sel p{
    font-weight: bold;
  }

  .source-page-list-body-right-error {
    height: 500px;
    justify-content: center;
  }

  .source-page-list-body-right-error img {
    margin-bottom: 10px;
  }

</style>

<style lang="scss" scoped>

  /deep/.el-input__inner {
    color: #fff;
    font-size: 14px;
    border: none;
    height: 38px;
    background-color: rgba($color: #fff, $alpha: 0);
  }

</style>
